var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"newspage-container"},[_c('van-sticky',[_c('head-bar',{attrs:{"title":"动态"},on:{"onClickLeft":_vm.onClickLeft}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }